export default __webpack_public_path__ + "static/chlamydia-gonorrhea-box@2x-5427af2c04813f3adab09e02d68192a3.png";